import React from "react";
import FooterLogo from "../../assets/Sun Kissed Delight logo (White Bg)(Round).svg";

const Footer = () => {
  return (
    <>
      <footer
        id="qodef-page-footer"
        className="qodef-skin--none"
        role="contentinfo"
      >
        <div id="qodef-page-footer-top-area">
          <div
            id="qodef-page-footer-top-area-inner"
            className="qodef-content-grid"
          >
            <div className="qodef-grid qodef-layout--columns qodef-responsive--custom qodef-col-num--4 qodef-col-num--1024--2 qodef-col-num--768--2 qodef-col-num--680--1 qodef-col-num--480--1">
              <div className="qodef-grid-inner clear">
                <div className="qodef-grid-item">
                  <div
                    id="custom_html-3"
                    className="widget_text widget widget_custom_html"
                    data-area="qodef-footer-top-area-column-1"
                  >
                    <div className="textwidget custom-html-widget">
                      <a href="/#">
                        <img
                          style={{ display: "inline-block", marginTop: 12 }}
                          src={FooterLogo}
                          alt="logo main"
                          width={150}
                          height={62}
                        />
                      </a>
                    </div>
                  </div>
                  <div
                    id="swissdelight_core_separator-7"
                    className="widget widget_swissdelight_core_separator"
                    data-area="qodef-footer-top-area-column-1"
                  >
                    <div className="qodef-shortcode qodef-m  qodef-separator clear ">
                      <div
                        className="qodef-m-line"
                        style={{ borderBottomWidth: 0, marginBottom: 40 }}
                      />
                    </div>
                  </div>{" "}
                </div>
                <div className="qodef-grid-item">
                  <div
                    id="nav_menu-2"
                    className="widget widget_nav_menu"
                    data-area="qodef-footer-top-area-column-2"
                  >
                    <h4 className="qodef-widget-title">Useful Links</h4>
                    <div className="menu-footer-column-2-container">
                      <ul id="menu-footer-column-2" className="menu">
                        <li
                          id="menu-item-3632"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-3632"
                        >
                          <a href="/about-us">About Us</a>
                        </li>
                        <li
                          id="menu-item-3633"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-3633"
                        >
                          <a href="/products">Shop Products</a>
                        </li>
                        <li
                          id="menu-item-3634"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-3634"
                        >
                          <a href="/about-us">How it Works</a>
                        </li>
                        <li
                          id="menu-item-3636"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-3636"
                        >
                          <a href="/contact-us">Contact Us</a>
                        </li>
                        <li
                          id="menu-item-3637"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-3637"
                        >
                          <a href="/terms">Terms and Conditions</a>
                        </li>
                        <li
                          id="menu-item-3637"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-3637"
                        >
                          <a href="/privacy-policy">Privacy policy</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    id="swissdelight_core_separator-8"
                    className="widget widget_swissdelight_core_separator"
                    data-area="qodef-footer-top-area-column-2"
                  >
                    <div className="qodef-shortcode qodef-m  qodef-separator clear ">
                      <div
                        className="qodef-m-line"
                        style={{ borderBottomWidth: 0 }}
                      />
                    </div>
                  </div>{" "}
                </div>

                <div className="qodef-grid-item">
                  <div
                    id="swissdelight_core_contact_form_7-2"
                    className="widget widget_swissdelight_core_contact_form_7"
                    data-area="qodef-footer-top-area-column-4"
                  >
                    <h4 className="qodef-widget-title">Contact Info</h4>{" "}
                    <div className="qodef-contact-form-7">
                      <div
                        className="wpcf7 no-js"
                        id="wpcf7-f3369-o1"
                        lang="en-US"
                        dir="ltr"
                      >
                        <div className="screen-reader-response">
                          <p
                            role="status"
                            aria-live="polite"
                            aria-atomic="true"
                          />{" "}
                          <ul />
                        </div>
                        <form
                          method="post"
                          className="wpcf7-form init demo"
                          aria-label="Contact form"
                          noValidate="novalidate"
                          data-status="init"
                        >
                          <p style={{ margin: 0 }}>
                            Need help or have questions?
                          </p>

                          <p style={{ margin: 0 }}>
                            <b>eykamwellness@gmail.com </b>
                          </p>

                          <p style={{ margin: 0 }}>
                            <b>WhatsApp / Call: +91-8800305043</b>
                          </p>

                          <div
                            className="wpcf7-response-output"
                            aria-hidden="true"
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  <div
                    id="swissdelight_core_social_icons_group-3"
                    className="widget widget_swissdelight_core_social_icons_group"
                    data-area="qodef-footer-top-area-column-4"
                  >
                    {" "}
                    <div className="qodef-social-icons-group">
                      <span
                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal"
                        style={{ margin: "-10px 21px 0px 0px" }}
                      >
                        <a
                          itemProp="url"
                          href="https://www.facebook.com/profile.php?id=61560025850257"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span
                            className="qodef-icon-ionicons ion-logo-facebook qodef-icon qodef-e"
                            style={{ fontSize: 19 }}
                          />{" "}
                        </a>
                      </span>

                      <span
                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal"
                        style={{ margin: "-10px 21px 0px 0px" }}
                      >
                        <a
                          itemProp="url"
                          href="https://www.linkedin.com/company/eykam-wellness/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span
                            className="qodef-icon-ionicons ion-logo-linkedin qodef-icon qodef-e"
                            style={{ fontSize: 19 }}
                          />{" "}
                        </a>
                      </span>

                      <span
                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--normal"
                        style={{ margin: "-10px 0px 0px 0px" }}
                      >
                        <a
                          itemProp="url"
                          href="https://www.instagram.com/eykam__wellness/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span
                            className="qodef-icon-ionicons ion-logo-instagram qodef-icon qodef-e"
                            style={{ fontSize: 19 }}
                          />{" "}
                        </a>
                      </span>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="qodef-page-footer-bottom-area">
          <div
            id="qodef-page-footer-bottom-area-inner"
            className="qodef-content-grid"
          >
            <div className="qodef-grid qodef-layout--columns qodef-responsive--custom qodef-col-num--1 qodef-alignment--center">
              <div className="qodef-grid-inner clear">
                <div className="qodef-grid-item">
                  <div
                    id="text-5"
                    className="widget widget_text"
                    data-area="qodef-footer-bottom-area-column-1"
                  >
                    {" "}
                    <div className="textwidget">
                      <p>© 2025 SunKissedDelight</p>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
